/* eslint-disable @typescript-eslint/no-unused-vars */
import { Router, NavigationEnd, RouterLinkActive, RouterLink } from '@angular/router';
import { DOCUMENT, NgClass } from '@angular/common';
import {
    Component,
    Inject,
    ElementRef,
    OnInit,
    Renderer2,
    HostListener,
} from '@angular/core';
import { AuthService } from '@core';
import { RouteInfo } from './sidebar.metadata';
import { TranslateModule } from '@ngx-translate/core';
import { FeatherModule } from 'angular-feather';
import { NgScrollbar } from 'ngx-scrollbar';
import { UnsubscribeOnDestroyAdapter } from '@shared';
import { PermissionTypeService } from '@core/service/permission-type.service';
import { SidebarService } from './sidebar.service';
import { Token } from '@core/models/token.model';
import { UserPhotoComponent } from '@shared/components/user-photo/user-photo.component';

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    imports: [
        NgScrollbar,
        RouterLinkActive,
        RouterLink,
        NgClass,
        FeatherModule,
        TranslateModule,
        UserPhotoComponent,
    ]
})
export class SidebarComponent extends UnsubscribeOnDestroyAdapter implements OnInit {
    public sidebarItems!: RouteInfo[];
    public innerHeight?: number;
    public bodyTag!: HTMLElement;
    listMaxHeight?: string;
    listMaxWidth?: string;
    headerHeight = 60;

    constructor(
        @Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,
        public elementRef: ElementRef,
        private authService: AuthService,
        private router: Router,
        private sidebarService: SidebarService,
        private readonly _permissionTypeService: PermissionTypeService,
    ) {
        super();
        this.subs.sink = this.router.events.subscribe({
            next: (event) => {
                if (event instanceof NavigationEnd) {
                    // close sidebar on mobile screen after menu select
                    this.renderer.removeClass(this.document.body, 'overlay-open');
                }
            }
        });
    }

    @HostListener('window:resize') windowResizecall() {
        this.setMenuHeight();
        this.checkStatuForResize(false);
    }

    @HostListener('document:mousedown', ['$event']) onGlobalClick(event: Event): void {
        if (!this.elementRef.nativeElement.contains(event.target)) {
            this.renderer.removeClass(this.document.body, 'overlay-open');
        }
    }

    ngOnInit() {
        this.createSubscriptions();
        this.setSidebar();
        this.initLeftSidebar();
        this.bodyTag = this.document.body;
    }

    private createSubscriptions(){
        this.subs.add(
            this.sidebarService.refreshSidebar$.subscribe({
                next: () => {
                    this.setSidebar();
                }
            })
        );
    }

    private setSidebar(){
        this.subs.add(
            this.sidebarService.getRouteInfo().subscribe({
                next: (routes: RouteInfo[]) => {
                    // this.sidebarItems = routes.filter((sidebarItem) => sidebarItem);
                    this.sidebarItems = routes.filter((sidebarItem) => {
                        return this._permissionTypeService.userHasAllPermissionTypes(sidebarItem.requiredPermissionTypes) && this._permissionTypeService.userHasAnyPermissionTypes(sidebarItem.anyPermissionTypes) && !this._permissionTypeService.userHasProhibitedPermissionTypes(sidebarItem.prohibitedPermissionTypes) && sidebarItem.visible !== false;
                    });
                }
            })
        );
    }

    callToggleMenu(event: Event, length: number) {
        if (length > 0) {
            const parentElement = (event.target as HTMLInputElement).closest('li');
            const activeClass = parentElement?.classList.contains('active');

            if (activeClass) {
                this.renderer.removeClass(parentElement, 'active');
            } else {
                this.renderer.addClass(parentElement, 'active');
            }
        }
    }

    initLeftSidebar() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this = this;
        // Set menu height
        _this.setMenuHeight();
        _this.checkStatuForResize(true);
    }

    setMenuHeight() {
        this.innerHeight = window.innerHeight;
        const height = this.innerHeight - this.headerHeight;
        this.listMaxHeight = height + '';
        this.listMaxWidth = '500px';
    }

    isOpen() {
        return this.bodyTag.classList.contains('overlay-open');
    }

    checkStatuForResize(firstTime: boolean) {
        if (window.innerWidth < 1025) {
            this.renderer.addClass(this.document.body, 'ls-closed');
        }
        else {
            this.renderer.removeClass(this.document.body, 'ls-closed');
        }
    }

    mouseHover() {
        const body = this.elementRef.nativeElement.closest('body');
        if (body.classList.contains('submenu-closed')) {
            this.renderer.addClass(this.document.body, 'side-closed-hover');
            this.renderer.removeClass(this.document.body, 'submenu-closed');
        }
    }

    mouseOut() {
        const body = this.elementRef.nativeElement.closest('body');
        if (body.classList.contains('side-closed-hover')) {
            this.renderer.removeClass(this.document.body, 'side-closed-hover');
            this.renderer.addClass(this.document.body, 'submenu-closed');
        }
    }

    // !!!
    get tokenUserName(): string{
        return this.authService.tokenUserName();
    }

    get token(): Token | null{
        return this.authService.token();
    }
}
